__turbopack_context__.v({
  "trigger": "topic-trigger-icon-module-scss-module__lD9VmW__trigger",
  "trigger__icon": "topic-trigger-icon-module-scss-module__lD9VmW__trigger__icon",
  "trigger__text": "topic-trigger-icon-module-scss-module__lD9VmW__trigger__text",
});
